const PASS = {state: true, message: ''}

export function regValidate(reg, message) {
  return value => {
    if (reg.test(value)) return PASS
    return {state: false, message}
  }
}

export const validateDomain = regValidate(/^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/i, '请输入正确的域名')
export const validateEmail = regValidate(/^([A-Za-z0-9_\-.\u4e00-\u9fa5])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/, '请输入正确的邮箱地址')

export function validatePhone(value) {
  let isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/
  let isMobile = /^0?1[3458][0-9]\d{8}$/
  let isInternational = /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/
  if (isMobile.test(value) || isPhone.test(value) || isInternational.test(value)) return PASS
  return {state: false, message: '请输入正确的联系电话'}
}

export function validateLength({min = 0, max = Infinity, message}) {
  if (!message) {
    if (max < Infinity) message = `请输入${min}-${max}个字符`
    else message = `请至少输入${min}个字符`
  }
  return value => value.length >= min && value.length <= max ? PASS : {state: false, message}
}

const singleValidate = (validator, value, form) => {
  let {required, validate, force, message = '请输入'} = validator
  if (required && !value) return {state: false, message}
  if (validate && (value || force)) return validate(value, form)
  return PASS
}

export class Validator {
  constructor(target, form, values) {
    this.__target__ = target
    this.__form__ = form
    this.__map__ = values
    this.__disallowed_blanks__ = false
  }

  add({field, required, validate, message}) {
    this.__map__[field] = {required, validate, message}
  }

  validate(field) {
    let validators = this.__map__[field]
    let form = this.__target__[this.__form__]
    let value = form[field]
    if (!validators || (!this.__disallowed_blanks__ && !value)) return PASS
    for (let i = 0; i < validators.length; i++) {
      let result = singleValidate(validators[i], value, form)
      if (!result.state) return result
    }
    return PASS
  }

  reset() {
    this.__disallowed_blanks__ = false
  }

  validateForm() {
    this.__disallowed_blanks__ = true
    for (let field in this.__map__) {
      let {state} = this.validate(field)
      if (!state) return false
    }
    return true
  }
}